import React, { useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header/Header';
import WhatsAppFloat from './components/WhatsAppFloat/WhatsAppFloat';
import Home from './pages/Home/Home';
import './App.css';

const Somos = lazy(() => import('./pages/Somos/Somos'));
const SouEner360 = lazy(() => import('./pages/SouEner360/SouEner360'));
const ClubeEner360 = lazy(() => import('./pages/ClubeEner360/ClubeEner360'));
const FluxoComercializacao = lazy(() =>
  import('./pages/FluxoComercializacao/FluxoComercializacao')
);
const ConsultoriaEnergia = lazy(() =>
  import('./pages/ConsultoriaEnergia/ConsultoriaEnergia')
);
const SeguroConsorcioFinanciamento = lazy(() =>
  import('./pages/SeguroConsorcioFinanciamento/SeguroConsorcioFinanciamento')
);
const IndiqueEGanhe = lazy(() => import('./pages/IndiqueEGanhe/IndiqueEGanhe'));
const FAQ = lazy(() => import('./pages/FAQ/FAQ'));
const Privacidade = lazy(() => import('./pages/LegalPage/Privacidade'));
const TermoUso = lazy(() => import('./pages/LegalPage/TermoUso'));
const Contato = lazy(() => import('./pages/Contato/Contato'));
const SimulacaoResultado = lazy(() =>
  import('./pages/SimulacaoResultado/SimulacaoResultado')
);
const Blog = lazy(() => import('./pages/Blog/Blog'));
const BlogPost = lazy(() => import('./pages/Blog/BlogPost'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));
const Footer = lazy(() => import('./components/Footer/Footer'));

const PageFallback = () => <div className='page-fallback' aria-hidden='true' />;

const AppContent = () => {
  const location = useLocation();

  const isStandalonePage = ['/privacidade', '/termo-uso'].includes(
    location.pathname
  );

  useEffect(() => {
    const anchorId = location.hash.slice(1);
    const anchor = anchorId ? document.getElementById(anchorId) : null;

    if (anchor) {
      anchor.scrollIntoView({ block: 'start', behavior: 'auto' });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [location]);

  if (isStandalonePage) {
    return (
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path='/privacidade' element={<Privacidade />} />
          <Route path='/termo-uso' element={<TermoUso />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <>
      <Header />
      <main className='main-content'>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/somos' element={<Somos />} />
            <Route path='/sou-ener360' element={<SouEner360 />} />
            <Route path='/clube-ener360' element={<ClubeEner360 />} />
            <Route
              path='/fluxo-comercializacao'
              element={<FluxoComercializacao />}
            />
            <Route path='/consultoria-energia' element={<ConsultoriaEnergia />} />
            <Route
              path='/seguro-consorcio-financiamento'
              element={<SeguroConsorcioFinanciamento />}
            />
            <Route path='/indique-e-ganhe' element={<IndiqueEGanhe />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/contato' element={<Contato />} />
            <Route
              path='/simulacao-resultado'
              element={<SimulacaoResultado />}
            />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:id' element={<BlogPost />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <WhatsAppFloat />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className='App'>
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
